<template>
  <v-stepper v-model="e6">
    <v-stepper-items>
      <v-stepper-content step="1">
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="cyan"
        ></v-progress-linear>
        <v-card v-else :disabled="loading" flat class="pa-2">
          <v-card-title>{{ $t("form.form_download") }}</v-card-title>
          <v-row v-if="awnsers.length > 0" flat class="pa-2">
            <v-col
              class="pa-1"
              cols="12"
              md="6"
              v-for="item in awnsers"
              :key="item.id"
            >
              <v-card flat class="pa-0 border d-flex rounded-xl">
                <v-card-text class="pa-0">
                  <v-card-title>
                    {{ $t("form.formdownload") }} {{ item.id }}
                  </v-card-title>
                  <v-card-subtitle class="d-flex">
                    {{ $t("form.create_at") }} {{ item.created_at_diff }} -
                    <p class="ma-0" dir="ltr">{{ item.created_at_p }}</p>
                  </v-card-subtitle>
                </v-card-text>

                <v-card-actions>
                  <v-btn
                    @click="
                      showItems = item.answer;
                      e6 = 2;
                    "
                    :loading="loading"
                    outlined
                    elevation="0"
                    color="green"
                  >
                    {{ $t("form.shown") }}
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-content-center" v-else>
            <v-card-subtitle>{{ $t("form.nogiveform") }}</v-card-subtitle>
          </v-row>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-row class="pa-2" dense>
          <v-col cols="12">
            <v-btn outlined color="red" @click="e6 = 1">
              <v-icon>mdi-chevron-right</v-icon>
              {{ $t("form.back") }}
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="pa-1"
            v-for="item in Object.keys(showItems)"
            :key="item"
          >
            <v-card class="pa-0 border rounded-xl" flat>
              <v-card-title>{{ item }} : </v-card-title>
              <v-card-subtitle>{{ showItems[item] }}</v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
export default {
  props: {
    qr_id: [String, Number],
  },
  data() {
    return {
      awnsers: [],
      e6: 1,
      showItems: {},
      loading: false,
    };
  },

  methods: {
    fetch() {
      if (!this.qr_id) {
        console.warn("qr_id تعریف نشده است، امکان دریافت اطلاعات وجود ندارد");
        this.$toast.error(this.$t("error.qr_id_missing"));
        this.loading = false;
        return;
      }
      this.loading = true;
      this.$api
        .get(`/v1/testQr/application/forms/answers`, {
          params: { qr_id: this.qr_id },
        })
        .then(({ data }) => {
          console.log("دریافت موفق، داده‌ها:", data.data);
          this.awnsers = data.data;
        })
        .catch((err) => {
          console.error("خطا در دریافت:", err);
          this.$toast.error(this.$t("error.fetch_failed"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPersianDate(dateString) {
      const date = new Date(dateString);
      if (isNaN(date)) return this.$t("form.invalid_date");
      const formatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      return formatter.format(date);
    },
  },

  mounted() {
    this.fetch();
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    qr_id: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.fetch();
          this.e6 = 1;
        }
      },
    },
  },
};
</script>

<style></style>
